import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'shared/components/Modal/Modal';
import Text from 'shared/components/Text/Text';
import { AppStoreIcon, GooglePlayIcon } from 'shared/components/icons';
import { useTheme } from 'styled-components';
import LINKS from 'shared/links';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import { AppStoreButtonsWrapper, MyEverBrightModalContent } from './MyEverBrightModal.styles';

const MyEverBrightQRCode = React.lazy(() => import('./MyEverBrightQRCode'));

export function MyEverBrightModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { t } = useTranslation('translation', { keyPrefix: 'onboarding.myeverbrightModal' });
  const theme = useTheme();

  return (
    <Modal
      isOpen={isOpen}
      contentLabel="MyEverBright Modal"
      padding="20px"
      styleVariant="tertiary"
      onRequestClose={onClose}
    >
      <MyEverBrightModalContent>
        <Text as="h2" $fontWeight={500} $fontSize={24}>
          {t('title')}
        </Text>
        <Text as="p">{t('body1')}</Text>
        <Suspense fallback={<LoadingSpinner />}>
          <MyEverBrightQRCode />
        </Suspense>
        <Text as="p">{t('body2')}</Text>
        <AppStoreButtonsWrapper>
          <a
            href={LINKS.MOBILE_APP_STOREFRONTS.apple}
            target="_blank"
            rel="noreferrer"
            aria-label="apple store icon"
          >
            <AppStoreIcon color={theme.colors.iconIconSecondaryGrey90} />
          </a>
          <a
            href={LINKS.MOBILE_APP_STOREFRONTS.google}
            target="_blank"
            rel="noreferrer"
            aria-label="google play store icon"
          >
            <GooglePlayIcon color={theme.colors.iconIconSecondaryGrey90} />
          </a>
        </AppStoreButtonsWrapper>
      </MyEverBrightModalContent>
    </Modal>
  );
}

export default MyEverBrightModal;
